import { render } from "./TestingBalancing.vue?vue&type=template&id=754e29ec&scoped=true"
const script = {}

import "./TestingBalancing.vue?vue&type=style&index=0&id=754e29ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-754e29ec"

export default script